import { takeEvery, call } from 'redux-saga/effects';
import { getAuthHeaders } from './get-auth-headers';
import { checkForAccess } from './check-for-access';
import { fetchCities } from './fetch-cities';

export function* getAuthHeadersSaga() {
  yield call(getAuthHeaders);
  yield takeEvery('REFRESH_TOKEN', getAuthHeaders);
}

export function* checkForAccessSaga() {
  yield takeEvery(['CHECK_FOR_ACCESS'], checkForAccess);
}

export function* fetchCitiesSaga() {
  yield takeEvery(['FETCH_CITIES'], fetchCities);
}
